/**
 * Styles
 * @type {exports}|string
 */
require('bootstrap/dist/css/bootstrap.min.css');
require('./styles/css/material.css');
require('./styles/main.scss');
require('normalize.css');
require('@fortawesome/fontawesome-free/js/all');

/**
 * Require CMS component styles. Load in after material css because it contains overrides.
 */
require('fuzzy-reaction/lib/styles/main.scss');

/**
 * Optional spinners css
 */
require('fuzzy-reaction/lib/styles/spinners.scss');

/**
 * Scripts
 * @type string
 */
require('bootstrap');
